import { useEffect, useState } from "react";

// =============================================================================
// useStickyState — 29 Oct 2026
// James (phone memo): "every time you go back or refresh it just goes back to
// the default display of that page … you'll be filtering and then it'll just
// cut back." A screen's filters, tab and search live here for the session:
// leave and come back, refresh, rotate — same view. Cleared when the browser
// tab closes (sessionStorage), so tomorrow starts clean.
// Key by screen, e.g. "assets:tab". A value given in the URL (?tab=) still
// wins on arrival — pass it as `override`.
// =============================================================================
export function useStickyState<T>(key: string, initial: T, override?: T | null | undefined): [T, (v: T | ((p: T) => T)) => void] {
  const [value, setValue] = useState<T>(() => {
    if (override !== undefined && override !== null && override !== "") return override as T;
    try {
      const raw = sessionStorage.getItem(`sticky:${key}`);
      if (raw != null) return JSON.parse(raw) as T;
    } catch { /* storage blocked — fine */ }
    return initial;
  });
  useEffect(() => {
    try { sessionStorage.setItem(`sticky:${key}`, JSON.stringify(value)); } catch { /* fine */ }
  }, [key, value]);
  return [value, setValue];
}
